import React from 'react';
import LocationHeader from '../LocationHeader';
import LocationContent from '../LocationContent';

const Location = () => {
    return (
        <>
            <LocationHeader />
            <LocationContent />
        </>
    );
};

export default Location;
